import React from 'react'
import { numberNotation } from '../../../utils/safe'
import { Imballi } from '../../atoms/NewIcons'
import Alert from '../../atoms/Alert/Alert'
import Trans from '../../atoms/Trans/Trans'
import useTrans from '../../../hooks/useTrans'
import { priceNotation } from '../../../utils/safe'
import Link from 'next/link'

const InfoQuantita = ({
  info,
  service_gift,
  articolo,
  prodotto,
  selectorTaglia,
  selectorColore,
}) => {
  const t = useTrans()
  return (
    <div className="info__quantita">
      <div className="info__quantita__head">
        <h3 className="info__quantita__title">
          {info?.disponibilitaRealeMaggiore
            ? t('Disponibilità totale: più di {0} pezzi', [numberNotation(info?.disponibilita)])
            : t('Disponibilità totale: {0} pezzi', [numberNotation(info?.disponibilita)])}
        </h3>
        {(!service_gift || service_gift?.premium) && (
          <p className="info__quantita__label">
            {service_gift && !service_gift.personalizzazione ? (
              <Trans
                chiave="Inserisci le quantità dei prodotti che desideri aggiungere al preventivo"
              />
            ) : (
              <Trans
                chiave="Inserisci le quantità dei prodotti che desideri personalizzare e/o aggiungere al
            preventivo"
              />
            )}
          </p>
        )}
      </div>

      {articolo?.acquistabile_multipli ? (
        <Alert
          full
          variant="info"
          placeholder={t('Articolo acquistabile solo a multipli di {0} pezzi', [
            articolo?.acquistabile_multipli,
          ])}
          className="info__quantita__multipli-alert"
        />
      ) : null}

      {articolo?.con_fasce && <Fasce articolo={articolo} t={t} />}

      <div className="info__quantita__wrapper">
        {info?.personalizzabile && (
          info?.quantita_minima_personalizzabile && (
            !service_gift || service_gift?.personalizzazione) && (
            <p>
              <Trans chiave="*Quantità minima personalizzabile:" />{' '}
              <strong>{numberNotation(info?.quantita_minima_personalizzabile)}</strong>{' '}
              <Trans chiave="pezzi" />
            </p>
          ))}
        {!service_gift?.attivo && (
          <p>
            <strong>
              <Trans chiave="*Sconto extra del 2%" />
            </strong>{' '}
            <Trans chiave="per ordini composti da imballi e/o sottoimballi originali" />
          </p>
        )}
        {(service_gift && service_gift?.attivo) && (
          <p>
            {service_gift.frase_supplementi_minimi ? (
              <Trans chiave="*Puoi personalizzare anche quantitativi inferiori, nel preventivo verrà calcolato un supplemento" />
            ) : (
              <>
                <Trans chiave="*Desideri personalizzare quantitativi inferiori?" /> <Link href="/contatti"><a><Trans chiave="Contattaci" /></a></Link>
              </>
            )}
          </p>
        )}
      </div>

      <div className="info__imballi">
        <div className="info__imballi__quantita">
          {info?.sotto_imballi > 0 && (
            <span className="info__imballi__quantita-item">
              <span className="info__imballi__quantita-icon">
                <Imballi />
              </span>
              <span className="info__imballi__quantita-label">
                <strong>{info?.sotto_imballi}</strong> <Trans chiave="pezzi per sotto imballi" />
              </span>
            </span>
          )}
          {info?.imballi > 0 && (
            <span className="info__imballi__quantita-item">
              <span className="info__imballi__quantita-icon">
                <Imballi />
              </span>
              <span className="info__imballi__quantita-label">
                <strong>{info?.imballi}</strong> <Trans chiave="pezzi per imballi" />
              </span>
            </span>
          )}
        </div>

        <div className="info__imballi__attributes">
          {(info?.colore || info?.taglia) && (
            <p className="info__imballi__referenza">
              <Trans chiave="Per referenza:" />
            </p>
          )}
          {info?.colore &&
            (selectorColore ? (
              selectorColore
            ) : (
              <p className="info__imballi__attribute">
                <Trans chiave="Colore" />:{' '}
                <span className="info__imballi__attribute-value">{info?.colore}</span>
              </p>
            ))}
          {info?.taglia &&
            (selectorTaglia ? (
              selectorTaglia
            ) : (
              <p className="info__imballi__attribute">
                <Trans chiave="Taglia" />:{' '}
                <span className="info__imballi__attribute-value">{info?.taglia}</span>
              </p>
            ))}
        </div>
      </div>
    </div>
  )
}

export default InfoQuantita

const Fasce = ({ articolo, t }) => {
  const orderedFasce = [...articolo.fasce].sort((a, b) => {
    return parseFloat(a.da) - parseFloat(b.da)
  })
  return (
    <div className="fasce">
      <div className="fasce__table">
        <div className="fasce__col">
          <div className="fasce__cell">
            <p className="fasce__cell-title">
              <Trans chiave="Quantità" />
            </p>
          </div>
          <div className="fasce__cell">
            <p className="fasce__cell-title">
              <Trans chiave="Prezzo" />
            </p>
            {articolo?.acquistabile_multipli && (
              <p className="fasce__multipli">
                {t("Vincolato all'acquisto di multipli di {0}", [articolo?.acquistabile_multipli])}
              </p>
            )}
          </div>
        </div>
        {orderedFasce?.map((item) => (
          <div className="fasce__col" key={`fascia-${item.da}`}>
            <div className="fasce__cell">
              <p className="fasce__cell-title">
                <Trans chiave="Da" /> {item.da}
              </p>
            </div>
            <div className="fasce__cell">{priceNotation(item.prezzo, 3)} €</div>
          </div>
        ))}
      </div>
    </div>
  )
}
